module.exports = __webpack_public_path__ + "img/table-pivot.7b512547.svg";